import React, { FunctionComponent, useEffect, useRef } from 'react';
import './contractFileView.scss';
import { currentUser } from './idp-auth';

const ContractFileView: FunctionComponent = () => {
    const iframeRef = useRef<HTMLIFrameElement>(null);

    const updateIframeToken = () => {
        const acqContractsUrl = process.env.REACT_APP_CONTRACT_FILE_SPA_URL;
        const user = currentUser();
        const token = user.accessToken;
        
        if (iframeRef.current && acqContractsUrl && token) {
            // Send the new token to the iframe instead of reloading it
            iframeRef.current.contentWindow?.postMessage({
                type: 'token-update',
                token: token
            }, acqContractsUrl);
        }
    };

    useEffect(() => {
        // Access to environment variables
        const acqContractsUrl = process.env.REACT_APP_CONTRACT_FILE_SPA_URL;
        const user = currentUser();
        const token = user.accessToken;

        if (iframeRef.current) {
            iframeRef.current.src = `${acqContractsUrl}?token=${token}`;
        }

        // Listen for token refresh events
        const handleTokenRefresh = () => {
            updateIframeToken();
        };

        // Listen for storage events (when token is updated in sessionStorage)
        window.addEventListener('storage', handleTokenRefresh);
        
        // Also listen for custom token refresh events
        window.addEventListener('token-refresh', handleTokenRefresh);

        const receiveMessage = (event: MessageEvent) => {
            if (event.origin === acqContractsUrl) {
                const { type, action } = event.data;
                
                if (type === "resize") {
                    const container = document.querySelector('.embed-container-acq-contracts') as HTMLElement;
                    if (container) {
                        container.style.paddingBottom = action;
                    }
                }
            }
        };

        window.addEventListener("message", receiveMessage, false);

        return () => {
            window.removeEventListener("message", receiveMessage, false);
            window.removeEventListener('storage', handleTokenRefresh);
            window.removeEventListener('token-refresh', handleTokenRefresh);
        };
    }, []);

    return (
        <>
            <div>
                <h3>Contract Files Upload</h3>
            </div>
            <div className="row" style={{ display: 'block' }}>
                <div className="col" style={{ padding: '0 15px 20px 15px' }}>
                    <div className="embed-container-acq-contracts">
                        <iframe 
                            ref={iframeRef}
                            id="external-app-iframe-acq-contracts" 
                            height="100%" 
                            width="100%" 
                            style={{ display: 'block' }}
                            frameBorder="0" 
                            allowFullScreen
                            title="Contract Files"
                        >
                            Not supported
                        </iframe>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ContractFileView;